module.exports = __webpack_public_path__ + "static/media/blogpost-2-cards.030e85e9.jpg";